/**
 * Link que aponta para o próprio evento: mesmo host, ou outro host que resolve
 * para o mesmo tenant (`gorn.evnttz.com.br` e o domínio próprio do evento).
 *
 * Existe porque o produtor cola no banner a URL pública da plataforma. Como
 * `<a href>` cru isso é um page load novo — e no WebView do app, com
 * `target=_blank`, abre fora da sessão e desloga. Interno vira navegação do
 * roteador, sem recarregar nem trocar de contexto.
 *
 * Devolve o caminho (`/lojinha?x=1#y`) ou `null` quando o link é externo, tem
 * protocolo que não é http(s), ou não dá para afirmar que é o mesmo evento.
 */
export const resolveInternalPath = (
  link: string | null | undefined,
  {
    currentHost,
    currentTenantSlug,
    resolveSlug
  }: {
    currentHost: string
    currentTenantSlug: string | null
    resolveSlug: (host: string) => string | null
  }
): string | null => {
  const value = link?.trim()
  if (!value) return null

  let parsed: URL
  try {
    parsed = new URL(value, `https://${currentHost}`)
  } catch {
    return null
  }
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null

  const sameHost = parsed.host.toLowerCase() === currentHost.toLowerCase()
  const sameTenant =
    currentTenantSlug !== null && resolveSlug(parsed.host) === currentTenantSlug
  if (!sameHost && !sameTenant) return null

  return `${parsed.pathname}${parsed.search}${parsed.hash}`
}
